import Search from "./Top/Search";
import SiteSelect from "./Top/SiteSelect";
import ItemList from './Content/ItemList/ItemList';
import Tree from './Tree/Tree';
import TopMenu from './Content/TopMenu/TopMenu';
import {PathPickerType} from '../../types/enums';
import {Dispatch} from 'redux';
import {Breadcrumb, Item, ModalProps, ModalState, SelectableSite} from '../../types/types';
import {
  fetchBreadcrumbs,
  fetchChildrenByFilter,
  fetchFolderChildren,
  fetchPreferences,
  fetchSites,
  fetchTreeChildren,
} from '../../actions';
import {Factory} from '../../utils/Factory';
import {path} from 'ramda';
import {ContentContext, TreeContext} from "../../utils/contexts";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { toggleModal } from "../../../ModalTest/actions";
import { Modal as EdocatModal } from '../../../ModalTest';
import Button from "../../../Button";

class Modal extends window.React.PureComponent<ModalProps, ModalState> {
  constructor(props: ModalProps) {
    super(props);

    this.state = Factory.GET_INITIAL_STATE(props.selected || {});
  }

  async componentDidMount() {
    const { multiSelect, selected, site } = this.props;

    this.fetchPreferences();

    const sites = await fetchSites();
    let selectedSite = sites[site] || Factory.GET_EMPTY_SITE();

    //If only one item should be selected and there is already one selected item, display its parent folder content.
    if (!multiSelect && selected && Object.keys(selected).length === 1) {
      await this.fetchBreadcrumbs(Object.keys(selected)[0], true);

      const currentBreadcrumbs = this.state.breadcrumbs;

      if (currentBreadcrumbs.length > 0) {
        const parent = currentBreadcrumbs[currentBreadcrumbs.length - 1];

        selectedSite = sites[currentBreadcrumbs[0].name] || Factory.GET_EMPTY_SITE();

        await Promise.all([this.fetchContent(undefined,parent.nodeRef), this.fetchTreeChildren(parent.nodeRef)]);
      }
    } else if (selectedSite.nodeRef) {
      await this.onSiteSelect(selectedSite);
    }

    this.setState({
      sites,
      currentSite: selectedSite,
    });
  }

  onSiteSelect = async (site: SelectableSite) => {
    const { searchQuery } = this.state;

    if (site) {
      await this.fetchContent(searchQuery, site.nodeRef, 1);

      await this.fetchTreeChildren(site.nodeRef);

      this.setState({
        currentSite: site,
        breadcrumbs: [{ name: site.label, nodeRef: site.nodeRef }],
      });
    } else {
      this.setState({
        content: [],
        page: 1,
        total: 0,
        treeItems: {},
        filter: '',
        currentSite: Factory.GET_EMPTY_SITE(),
        breadcrumbs: [],
      });
    }
  };

  onBreadcrumbClick = async (breadcrumb: Breadcrumb) => {
    const { searchQuery } = this.state;
    await this.fetchContent(searchQuery, breadcrumb.nodeRef, 1);

    this.setState(oldState => ({
      breadcrumbs: [...oldState.breadcrumbs.slice(0, oldState.breadcrumbs.indexOf(breadcrumb) + 1)],
    }));
  };

  onItemSelect = (item: Item) => {
    const { type, multiSelect } = this.props;
    const { selected } = this.state;

    if (type === PathPickerType.ALL || type === item.type) {
      let newSelected = {
        ...selected,
      };

      const isSelectedItem = selected[item.nodeRef];
      if (isSelectedItem) {
        delete newSelected[item.nodeRef];
      } else {
        if (multiSelect) {
          newSelected[item.nodeRef] = item.nodeRef;
        } else {
          newSelected = {
            [item.nodeRef]: item.nodeRef,
          };
        }
      }
      
      this.setState({
        selected: newSelected,
        selectedName: multiSelect || isSelectedItem ? '' : item.name,
      });
    }
  };

  //Used in case of search result folder open

  // onFolderOpen = async (item: Item) => {
  //   const { nodeRef, name, path } = item;
  //   const { searchQuery, selected, breadcrumbs } = this.state;
  //   const { type, multiSelect } = this.props;
  //
  //   const { items, total } = await fetchFolderChildren(nodeRef, type);
  //
  //   const isSearchResult: boolean = searchQueryIsNotEmpty(searchQuery);
  //
  //   //In single select mode, choose the opened folder, if it is empty.
  //   const newSelected = multiSelect ? selected : items.length === 0 ? { [item.nodeRef]: item.nodeRef } : {};
  //
  //   //If the opened folder is a search result item, set its path to breadcrumbs.
  //   const newBreadcrumbs = isSearchResult
  //     ? [...(path || []), { name, nodeRef }]
  //     : [...breadcrumbs, { name, nodeRef }];
  //
  //   this.setState(oldState => ({
  //     content: items,
  //     selected: newSelected,
  //     breadcrumbs: newBreadcrumbs,
  //     //If the opened folder is a search result item, treat search finished: stop showing paths and clear search query
  //     searchMode: isSearchResult ? false : oldState.searchMode,
  //     searchQuery: isSearchResult ? '' : oldState.searchQuery,
  //     total,
  //   }));
  // };

  doSearch = async (
      searchQuery: string,
      nodeRef: string = '',
      skipCount: number = 0,
      pageSize: number = this.state.pageSize,
      page: number = this.state.page,
      sortByValue: string = this.state.sortByValue,
      sort: boolean = this.state.sort
    ) => {
    const { type, name } = this.props;
    const { breadcrumbs } = this.state;

    const rootNodeRef: string = nodeRef || breadcrumbs[breadcrumbs.length - 1]?.nodeRef;

    this.setState({
      loadingContent: true,
    });

    const { items, total, isSiteRoot } = await fetchFolderChildren({
      filter: searchQuery,
      folderNodeRef: rootNodeRef,
      type,
      page,
      sort,
      sortByValue,
      pageSize,
      pickerName: name
    });

    this.setState(() => ({
      content: items,
      searchMode: false,
      total,
      loadingContent: false,
    }));
  };

  fetchContent = async (
    searchQuery: string = this.state.searchQuery,
    nodeRef: string = '',
    page: number = this.state.page,
    sort: boolean = this.state.sort,
    sortByValue: string = this.state.sortByValue,
    pageSize: number = this.state.pageSize
    ) => {

    const { selected, breadcrumbs, switchValue, currentSite } = this.state;
    const { multiSelect, type, name } = this.props;

    const rootNodeRef: string = nodeRef || breadcrumbs[breadcrumbs.length - 1]?.nodeRef;

    this.setState({
      loadingContent: true,
    });
    try {
        const {items, total} = await fetchFolderChildren({
        folderNodeRef: currentSite && searchQuery && switchValue ? currentSite.nodeRef : rootNodeRef,
        filter: searchQuery,
        type,
        page,
        sort,
        sortByValue,
        pageSize,
        pickerName: name,
      });
      this.setState(() => ({
        content: items,
        searchMode: false,
        total,
        loadingContent: false,
      }));
    } catch(e) {
      this.setState(() => ({
        content: [],
        searchMode: false,
        total: 0,
        loadingContent: false,
      }));
    }
  };

  fetchChildrenByFilter = async (filter: string) => {
    const { currentSite, sort, sortByValue, pageSize } = this.state;
    const { type } = this.props;

    const { items, total } = await fetchChildrenByFilter(currentSite.value, filter, type, 1, sort, sortByValue, pageSize);

    this.setState(() => ({
      content: items,
      searchMode: false,
      total,
    }));
  };

  fetchTreeChildren = async (nodeRef: string = '') => {
    const { breadcrumbs } = this.state;

    const rootNodeRef: string = nodeRef || breadcrumbs[breadcrumbs.length - 1]?.nodeRef;

    this.setState({
      loadingItem: rootNodeRef,
    });

    const newTreeItems = await fetchTreeChildren(rootNodeRef);

    this.setState(state => ({
      treeItems: {
        ...state.treeItems,
        ...newTreeItems,
      },
      loadingItem: '',
    }));
  };

  fetchBreadcrumbs = async (nodeRef: string, parentPath: boolean = false) => {
    const { sites } = this.state;

    let breadcrumbs = await fetchBreadcrumbs(nodeRef, parentPath);

    if (breadcrumbs.length > 0 && sites[breadcrumbs[0].name]) {
      breadcrumbs = [{
        nodeRef: breadcrumbs[0].nodeRef,
        name: sites[breadcrumbs[0].name].label,
      }, ...breadcrumbs.slice(1)];
    }

    this.setState({
      breadcrumbs,
    });
  };

  fetchPreferences = async () => {
    if (window.Alfresco?.constants?.USERNAME) {
      this.setState(() => ({
        loadingContent: true,
      }));

      const { favouriteDocuments, favouriteFolders } = await fetchPreferences();

      this.setState({
        favouriteDocuments,
        favouriteFolders,
        loadingContent: false,
      });
    }
  };

  setProperty = (name: string, value: any) => {
    //@ts-ignore
    this.setState({
      [name]: value,
    });
  }

  onSubmit = async () => {
    const { selected } = this.state;
    const { onSubmit, library, name } = this.props;

    const selectedArr = Object.keys(selected);

    if (selectedArr.length > 0 && onSubmit) {
      this.setState({
        loadingContent: true,
      });
      await onSubmit(selectedArr);
      if(name === "moveModal" && library?.contextMenu?.nodeRef === library?.parent && library?.parentProps?.["niceURL:niceURL"]){
        window.location.href = `${window.appContext}/page/browse/${library.parentProps["niceURL:niceURL"]}`
      }
      this.onClose();
    }
  };

  onClose = () => {
    const { formInstanceId, actions, name } = this.props;

    actions.toggleModal(false, name, null, formInstanceId);
  };

  render() {
    const { sites, currentSite, selectedName, content, breadcrumbs, searchQuery, switchValue, selected, treeItems, loadingItem, sort, sortByValue, page, total, pageSize, filter, searchMode, loadingContent, favouriteDocuments, favouriteFolders, } = this.state;
    const { type, reducerPath, name, multiSelect, hidden, title, initialText } = this.props;

    const contentContext = {
      sites,
      breadcrumbs,
      content,
      onBreadcrumbClick: this.onBreadcrumbClick,
      onItemSelect: this.onItemSelect,
      selected,
      fetchContent: this.fetchContent,
      fetchChildrenByFilter: this.fetchChildrenByFilter,
      fetchTreeChildren: this.fetchTreeChildren,
      fetchBreadcrumbs: this.fetchBreadcrumbs,
      setProperty: this.setProperty,
      fetchPreferences: this.fetchPreferences,
      searchQuery,
      switchValue,
      sort,
      sortByValue,
      page,
      total,
      pageSize,
      filter,
      type,
      multiSelect,
      currentSite,
      searchMode,
      hidden,
      loadingContent,
      favouriteDocuments,
      favouriteFolders,
      initialText,
    };

    const treeContext = {
      treeItems,
      currentSite,
      fetchContent: this.fetchContent,
      fetchTreeChildren: this.fetchTreeChildren,
      fetchBreadcrumbs: this.fetchBreadcrumbs,
      selected,
      loadingItem,
      breadcrumbs,
      searchMode,
      switchValue,
      searchQuery,
    };

    const standardTitle =
      window.Alfresco.messages.global[
        `edocat.global.path-picker.select-${type === PathPickerType.FOLDER ? 'folder' : 'file'}`
        ];

    const modalState = reducerPath ? path([...reducerPath, name], this.props) : this.props.modal[name];

    return (
      <EdocatModal
        name={name}
        title={title || standardTitle}
        className="PathPicker-Modal"
        hideActionButtons
        onClose={this.onClose}
        reducerPath={reducerPath}
        fullWidth
      >
        <div className="modal-body" id="path-picker-body">
          <div className="Top">
            <SiteSelect
              onSiteSelect={this.onSiteSelect}
              currentSite={currentSite}
              loadingContent={loadingContent}
              sites={sites}
            />
            <Search
              fetchContent={this.fetchContent}
              searchQuery={searchQuery}
              setProperty={this.setProperty}
              loadingContent={loadingContent}
              switchValue={switchValue}
              type={type}
              currentSite={currentSite}
            />
          </div>
          <div className="Bottom">
            {currentSite.nodeRef && (searchQuery === "" || !switchValue && searchQuery !== "") && (
              <div className="Tree">
                <TreeContext.Provider value={treeContext}>
                <Tree />
                </TreeContext.Provider>
              </div>
            )}
            <div className="Content">
              <ContentContext.Provider value={contentContext}>
                {((currentSite.nodeRef && (!switchValue && searchQuery !== "" || searchQuery === "")) || (content.length > 0)) && <TopMenu />}
                <ItemList />
              </ContentContext.Provider>
            </div>
          </div>
        </div>
        <div className="modal-actions">
            {selectedName && (
              <div style={{marginRight: "10px"}}>{title} {selectedName}</div>
            )}
            <Button
              primary
              label={modalState?.items?.okLabel || window.Alfresco.messages.global['button.ok']}
              onClick={this.onSubmit}
              disabled={Object.keys(selected).length === 0}
            />
            <Button
              label={modalState?.items?.cancelLabel || window.Alfresco.messages.global['button.close']}
              onClick={this.onClose}
            />
        </div>
      </EdocatModal>
    );
  }
}

const mapStateToProps = (state: any) => ({
  ...state,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: bindActionCreators({ toggleModal }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Modal);
